export const NUM_RESULT_PLAN_TYPE_SHORT = 3;
export const NUMBER_CALLS_BY_PLAN_INTERNET = 3;